<template>
	<div id="admin2" :env="env">
		<app-header
			v-if="notLogin"
			ref="appHeader"
			:class="{ glowpick: $route.params.type === 'v-app' }"
		/>

		<app-main-v3 v-if="$route.params.type === 'v3'" />
		<v-app v-else-if="$route.params.type === 'v-app'" class="glowpick">
			<v-main>
				<router-view ref="main" />
			</v-main>
		</v-app>

		<app-main v-else />
		<modal-box v-if="isOpen && notLogin" />
		<spinner-box v-show="activeSpinner" />
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import config from '@/config';
	import AppHeader from '@/components/layout/AppHeader.vue';
	import AppMain from '@/components/layout/AppMain.vue';
	import AppMainV3 from '@/components/layout/AppMainV3.vue';
	import ModalBox from '@/components/modals/ModalBox.vue';
	import SpinnerBox from '@/components/SpinnerBox.vue';

	export default {
		name: 'App',
		components: { AppHeader, AppMain, AppMainV3, ModalBox, SpinnerBox },
		data() {
			return {
				env: config.env,
			};
		},
		computed: {
			...mapState({
				activeSpinner: state => state.activeSpinner,
				isOpen: state => state.modal.isOpen,
			}),
			notLogin() {
				return this.$route.name && this.$route.name !== 'Login';
			},
		},
		mounted() {
			window.addEventListener('click', this.clickApp);
		},
		methods: {
			clickApp(event) {
				const appHeader = this.$refs.appHeader;
				if (appHeader) {
					const className = event.target.className;

					if (
						typeof className === 'object' ||
						(className.indexOf('nav-box__nav1__btn') < 0 &&
							className.indexOf('btn-menu') < 0)
					) {
						appHeader.nav1Open = false;
						appHeader.menuIsOpen = false;
					}
				}
			},
		},
		watch: {
			'$route.query'(query) {
				const copiedQuery = { ...query };
				if (copiedQuery.reload) {
					delete copiedQuery.reload;
					this.$router.replace({ query: copiedQuery });
					window.location.reload();
				}
			},
		},
	};
</script>
<style lang="scss">
	@import './assets/style/fonts/index.scss';
	$fa-font-path: '~font-awesome/fonts/';
	@import '~font-awesome/scss/font-awesome';
	@import './assets/style/common.scss';
</style>
